export type RenderProps = {
  show: boolean;
};

/**
 * Renderiza condicionalmente os seus filhos
 */
export const Render: React.FC<React.PropsWithChildren<RenderProps>> = ({
  children,
  show,
}) => {
  if (!show) return null;

  return <>{children}</>;
};
